import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import HeaderUser from "./content/header";
import Footer from "../pages/content/footer"
import {Helmet} from 'react-helmet'


import AllCoursesIndex from "../pages/content/allcourses"

class Posgraduacao extends Component {


 

  render() {
    return (
      <React.Fragment>
        
        <HeaderUser />
        <br></br>
        <AllCoursesIndex />


      
      <br></br>
      <Footer />
      </React.Fragment>
       
    );
  }
}

export default withRouter(Posgraduacao);


// WEBPACK FOOTER //
// ./src/pages/posgraduacao.js